import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router } from '@angular/router';
import { NodeServiceResourceService } from '@psnb/nwt-api';
import { NetworkHierarchyRegion, PowerSupply, UserDetails } from '@psnb/psnb-api';
import {
  AccessLogService,
  AuthService,
  CommunityServedService,
  isDefinedNotNullNotEmpty,
  PowerSupplyService,
  PSScrollerUpdatesCodeService
} from '@psnb/services';
import { debounceTime } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../common/common.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'nwt-power-supply-notebook',
  templateUrl: './power-supply-notebook.component.html',
  styleUrls: ['./power-supply-notebook.component.scss']
})
export class PowerSupplyNotebookComponent implements OnInit {
  showMessage: boolean = false;
  message: string = '';
  duration: string = '';
  searchResult: any[] = [
  ];
  psNameSearchResult: PowerSupply[] = [];
  headendOrTownSearchResult: PowerSupply[] = [];
  macSearchResult: PowerSupply[] = [];
  psIDResult: PowerSupply[] = [];
  addressSearchResult: PowerSupply[] = [];

  searchText = '';
  mac_address = '';
  remcolon = '';
  searchTerm: FormControl = new FormControl();
  powerSupplyNameSearchTerm: FormControl = new FormControl();
  headendSearchFormControl: FormControl = new FormControl();
  //regionFormControl: FormControl = new FormControl('', [Validators.required]);
  gpsLatControl: FormControl = new FormControl('', [Validators.required]);
  gpsLongControl: FormControl = new FormControl('', [Validators.required]);
  macSearchFormControl: FormControl = new FormControl();
  psIdControl: FormControl = new FormControl();
  addressSearchFormControl: FormControl = new FormControl();
  textFieldFromControl = new FormControl('', [Validators.required]);
  matcher = new MyErrorStateMatcher();
  userDetails: UserDetails;
  regionList: NetworkHierarchyRegion[] = [];
  isLoadingmacdata: boolean;
  searchnodeFlag:boolean = true;
  nodeValue:any;
  userpermissions:any;

  constructor(
    private nodeService: NodeServiceResourceService,
    private router: Router,
    private powerSupplyService: PowerSupplyService,
    private authService: AuthService,
    private accessLogService: AccessLogService,
    private communityServedService: CommunityServedService,
    private psScrollerUpdatesCodeService: PSScrollerUpdatesCodeService,
    private commonService: CommonService) {
    this.searchTerm.valueChanges
      .pipe(debounceTime(1000))
      .subscribe(data => {
        this.search_word(data.trim()).subscribe(response => {
          this.searchResult = response.map(item => item);
        });
      });

      this.powerSupplyNameSearchTerm.valueChanges
      .pipe(debounceTime(1000))
      .subscribe(data => {
        if (data !== '') {
          this.powerSupplyService.advanceSearchByPowerSupplyName(data).subscribe(
            response => {
              this.psNameSearchResult = response;
            });
        }
      });

    this.headendSearchFormControl.valueChanges
      .pipe(debounceTime(1000))
      .subscribe(data => {
        if (data !== '') {
          this.powerSupplyService.advanceSearchByHeadendOrTown(data).subscribe(
            response => {
              this.headendOrTownSearchResult = response;
            });
        }
      });


    this.macSearchFormControl.valueChanges
      .pipe(debounceTime(1000))
      .subscribe(data => {
        if (data !== '') {
          this.isLoadingmacdata = true;
          if (this.mac_address == '') {
            this.remcolon = data.toString().replace(/:/g, "");
            let remcolonupdate = this.remcolon.replace(/\s/g, "");
            const blocks = remcolonupdate.match(/.{1,2}/g);
            let formattedMac = blocks.shift();
             for (const block of blocks) {
               formattedMac  = formattedMac  + ':' + block;
             }
             this.mac_address = formattedMac;
          } else {
            this.remcolon = data.toString().replace(/:/g, "");
            let remcolonupdate = this.remcolon.replace(/\s/g, "");
            const blocks = remcolonupdate.match(/.{1,2}/g);
            let formattedMac = blocks.shift();
             for (const block of blocks) {
               formattedMac  = formattedMac  + ':' + block;
             }
             this.mac_address = formattedMac;
          }
          this.powerSupplyService.advancePowerSupplyMacSearch(this.mac_address.trim()).subscribe(
            response => {
              this.isLoadingmacdata = false;
              this.macSearchResult = response;
            });
        }
      });

  this.psIdControl.valueChanges
    .pipe(debounceTime(1000))
    .subscribe(data => {
      if (data !== '') {
        this.powerSupplyService.advancePowerSupplyPSID(data).subscribe(
          response => {
            this.psIDResult = response;
          });
      }
    });

    this.addressSearchFormControl.valueChanges
      .pipe(debounceTime(1000))
      .subscribe(data => {
        if (data !== '') {
          this.powerSupplyService.advanceSearchByAddress(data).subscribe(
            response => {
              this.addressSearchResult = response;
            });
        }
      });
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 58));
  }

    searchByPowerSupplyName(e: MatAutocompleteSelectedEvent) {
    const message = "Search by PowerSupply Name " + e.option.value.powerSupplyName;
    const activity = 'PowerSupply Search';
    this.commonService.loggerPost(message, activity, 3);
    this.router.navigate(['/list'], { queryParams: { powerSupplyName: e.option.value.powerSupplyName } });
  }
  getPowerSupplyName(option) {
    if (option) {
      return option.powerSupplyName;
    }
  }
  searchByMacAddress(e: MatAutocompleteSelectedEvent) {
    const message = "Search by MAC Address " + e.option.value.mac ;
    const activity = 'PowerSupply Search';
    this.commonService.loggerPost(message, activity, 3);
    this.mac_address = '';
    this.mac_address = e.option.value.mac;
    setTimeout(()=>{
      this.router.navigate(['/list'], { queryParams: { macAddress: e.option.value.mac } });
    },500);

  }
  getMacAddress(option) {
    if (option) {
      return option.mac;
    }
  }

  searchByHeadendOrCommunity(e: MatAutocompleteSelectedEvent) {

    const message = "Search by Town/Headend " + e.option.value.headendOrTown;
    const activity = 'PowerSupply Search';
    this.commonService.loggerPost(message, activity, 3);
    this.router.navigate(['/list'], { queryParams: { headendOrCommunity: e.option.value.headendOrTown } });
  }
  getHeadendOrTown(option) {
    if (option) {
      return option.headendOrTown;
    }
  }
  searchByAddress(e: MatAutocompleteSelectedEvent) {
    const message = "Search by Address " + e.option.value.address;
    const activity = 'PowerSupply Search';
    this.commonService.loggerPost(message, activity, 3);
    this.router.navigate(['/list'], { queryParams: { address: e.option.value.address } });
  }
  getAddress(option) {
    if (option) {
      return option.address;
    }
  }
  searchByLocation(latitude, longitude) {
    const message = `Search by latitude: ${latitude}, longitude: ${longitude}`;
    const activity = 'PowerSupply Search';
    this.commonService.loggerPost(message, activity, 3);
    this.router.navigate(['/list'], { queryParams: { latitude: latitude, longitude: longitude, regionId: null } });
  }
  nodeSelected(e: MatAutocompleteSelectedEvent) {
    let selectedValue = e.option.value;
    const message = `Search by Node ${selectedValue.node}`;
    const activity = 'PowerSupply Search';
    this.commonService.loggerPost(message, activity, 3);
    e.option.value = `${selectedValue.node} / ${selectedValue.nodeCmts}`;
    this.communityServedService.communityServed = e.option.value.nodeCommunintyServed;
    this.router.navigate(['/list'], { queryParams: { nodeCommunintyServed: selectedValue.nodeCommunintyServed, node: selectedValue.node, nodeId: selectedValue.nodeId } });
  }
  getNodeName(option) {
    if (option) {
      return `${option.node} / ${option.nodeCmts}`;
    }
  }

  searchPSID(e: MatAutocompleteSelectedEvent){
    const message = "Search by PS ID ";
    const activity = 'PowerSupply Search - By PS ID';
    this.commonService.loggerPost(message, activity, 3);
    // alert(`${JSON.stringify(e.option.value)}`);
    this.router.navigate(['/list'], { queryParams: { powerSupplyId: e.option.value.powerSupplyId } });
  }
  getpowerSupplyId(option) {
    if (option) {
      return option.powerSupplyId;
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public ngOnInit(): void {
    this.fetchMessageAndDuration();

    if (this.userpermissions === '' || !this.authService.isAuthorizedPSNBUser) {
      this.router.navigate(['/unauthorized']);
      return;
    }

    this.authService.getAccessToken(environment.scope)
      .subscribe(async (token: string): Promise<void> => {
        if (isDefinedNotNullNotEmpty(token) && await this.authService.checkUserDetails() &&
            isDefinedNotNullNotEmpty(this.authService.getUserDetails.userName)) {
          this.userDetails = this.authService.getUserDetails;
          this.accessLogService.createAccessLog(
            {
              accessedByEmail: this.userDetails.email,
              accessedByName: `${this.userDetails.lastName}, ${this.userDetails.firstName}`,
              accessedByNt: this.userDetails.userName.split('\\')[1]
            }
          ).subscribe();
        }
      });
  }

  private fetchMessageAndDuration(): void {
    this.psScrollerUpdatesCodeService.fetchActiveScroller().subscribe((data) => {
      if(data.ntId != null){
      this.message = data.message;
      this.duration = data.duration;
      this.showMessage = true;

      setTimeout(() => {
        this.showMessage = false;
      }, this.parseDuration(this.duration));
    }
    });
  }

  private parseDuration(duration: string): number {
    const [hours, minutes, seconds] = duration.split(':').map(Number);
    return (hours * 60 * 60 + minutes * 60 + seconds) * 1000; // Convert to milliseconds
  }


  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {

      navigator.geolocation.getCurrentPosition(resp => {
        this.gpsLatControl.setValue(resp.coords.latitude.toFixed(6));
        this.gpsLongControl.setValue(resp.coords.longitude.toFixed(6));
        resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
      },
        err => {
          reject(err);
        });
    });

  }

  getRegionsList() {
    this.powerSupplyService.getRegionsList()
      .subscribe(result => {
        result.forEach(regions => {
          this.regionList.push(regions);
        });
      },
        err => {
          console.error('ERROR in getRegions' + err.error);
        });
  }

  search_word(term) {
    return this.nodeService.resourceNodeServiceResourceAdvancedSearchGET(term);
  }

  changed() {
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        if (position) {
          this.gpsLatControl.setValue(position.coords.latitude.toFixed(6));
          this.gpsLongControl.setValue(position.coords.longitude.toFixed(6));
        }
      },
        (error) => console.log(error));
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }
  onChangesearchpowersupplies(event){
    this.nodeValue = event.target.value;
    if(this.nodeValue.length >= 4){
      this.searchnodeFlag = false;
    }else{
      this.searchnodeFlag = true;
    }
  }
  onchangesearchPSNav(){
    this.router.navigate(['/list'], { queryParams: { nodeText: this.nodeValue } });
  }


}
